import { render, staticRenderFns } from "./PannelThree.vue?vue&type=template&id=5aaa2238&scoped=true&"
import script from "./PannelThree.vue?vue&type=script&lang=js&"
export * from "./PannelThree.vue?vue&type=script&lang=js&"
import style0 from "./PannelThree.vue?vue&type=style&index=0&id=5aaa2238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa2238",
  null
  
)

export default component.exports